// File: src/components/Footer.jsx
import React from 'react';
import { FaGithub, FaLinkedin, FaTree} from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="py-8 bg-gray-800 dark:bg-gray-950 text-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-center md:text-left">
              © {new Date().getFullYear()} Sebastián Glonek. All rights reserved.
            </p>
          </div>
          
          <div className="flex space-x-4">
            <a
              href="https://github.com/De-Fo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-primary-light dark:hover:text-primary-dark transition-colors"
            >
              <FaGithub size={20} />
            </a>
            <a
              href="https://www.linkedin.com/in/sebasti%C3%A1n-glonek-208852216/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-primary-light dark:hover:text-primary-dark transition-colors"
            >
              <FaLinkedin size={20} />
            </a>
            <a
              href="https://sebastianglonek.org/linktree.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-primary-light dark:hover:text-primary-dark transition-colors"
            >
              <FaTree size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;